import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const About = () => {
  const { t } = useLanguage();
  const highlightCards = t('about.highlights', []);
  const highlights = Array.isArray(highlightCards) ? highlightCards : [];
  const highlightIcons = [
    (
      <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
    (
      <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )
  ];
  
  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-max">
        <div className="max-w-4xl mx-auto text-center">
          {/* Section Title */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-blue-500 mb-6 sm:mb-8 px-2">
            {t('about.title')}
          </h2>
          
          {/* About Content */}
          <div className="bg-white rounded-xl sm:rounded-2xl border-2 border-blue-500 p-6 sm:p-8 md:p-12">
            <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
              {t('about.description')}

              {t('about.betaNotice')}
            </p>
          </div>
          
          {/* Mission Statement */}
          <div className="mt-8 sm:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center px-2">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">{t('about.mission')}</h3>
              <p className="text-sm sm:text-base text-gray-600">{t('about.missionText')}</p>
            </div>
            
            {highlights.map((card, index) => (
              <div key={card.title} className="text-center px-2">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  {highlightIcons[index % highlightIcons.length]}
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">{card.title}</h3>
                <p className="text-sm sm:text-base text-gray-600">{card.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 